import { ChangeDetectionStrategy, Component } from '@angular/core';
import { NgbCollapseModule } from '@ng-bootstrap/ng-bootstrap';
import { AnatomicalSideLabelPipe, BaseMaTableComponent } from '../../shared';


/**
* Table of Limb Length Discrepancy in correction analysis.
*/
@Component({
	selector: 'lld-recap',
	templateUrl: './lld-recap.component.html',
	imports: [
		NgbCollapseModule,
		AnatomicalSideLabelPipe
	],
	changeDetection: ChangeDetectionStrategy.Eager,
})
export class LldRecapComponent extends BaseMaTableComponent {

	isCollapsed = true;

}
